import React, {Component} from 'react';

import './index.css';
import {debounce} from 'utils/General';


class InputText extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
        };
        const {debounceTime} = props;
        this.handleChangeWithDebounce = debounce(this.handleChange, debounceTime);
    }

    handleChange = (value) => {
        const {validate, handleChange} = this.props;
        try {
            validate(value);
            this.setState({
                error: null,
            });
            handleChange(value);
        } catch (err) {
            console.log(err)
            this.setState({
                error: err,
            });
        }
    };

    render() {
        const {
            placeholder, disabled, defaultValue, maxLength, controlled, value, inputStyles,
        } = this.props;
        const {error} = this.state;

        const className = error === null ? 'custom-input-text' : 'custom-input-text error';

        if (controlled) {
            return (
                <input
                    type="text"
                    value={value}
                    style={inputStyles}
                    maxLength={maxLength}
                    className={className}
                    placeholder={placeholder}
                    disabled={disabled}
                    onChange={(event) => {
                        this.handleChange(event.target.value);
                    }}
                />
            );
        }

        return (
            <input
                type="text"
                style={inputStyles}
                maxLength={maxLength}
                className={className}
                defaultValue={defaultValue}
                placeholder={placeholder}
                disabled={disabled}
                onChange={(event) => {
                    this.handleChangeWithDebounce(event.target.value);
                }}
            />
        );
    }
}

InputText.propTypes = {
    // placeholder: PropTypes.string,
    // width: PropTypes.string,
    // height: PropTypes.string,
    // validate: PropTypes.func,
    // handleChange: PropTypes.func,
    // debounceTime: PropTypes.number,
    // disabled: PropTypes.bool,
    // defaultValue: PropTypes.number,
    // maxLength: PropTypes.number,
    // controlled: PropTypes.bool,
    // value: PropTypes.string,
    // inputStyles: PropTypes.object,
};


InputText.defaultProps = {
    placeholder: '',
    width: '85px',
    height: '32px',
    validate: () => true,
    handleChange: () => true,
    debounceTime: 500,
    disabled: false,
    defaultValue: '',
    maxLength: 1000000000,
    controlled: false,
    value: '',
    inputStyles: {},
};

export default InputText;



// WEBPACK FOOTER //
// ./src/components/input-text/index.jsx